<template>
  <v-container fluid class="asc-power-bi-template">
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <template v-if="!isPowerBiPageActive">
          <asc-page-coming-soon
            label="Power BI Page Coming Soon!"
          ></asc-page-coming-soon>
        </template>
        <template v-if="isPowerBiPageActive">
          <asc-page-header>
            <template #pageTitle>
              <asc-page-title title="DASHBOARDS"></asc-page-title>
            </template>
          </asc-page-header>

          <asc-tab
            id="asc-main-tabs"
            v-model="selectedTab"
            secondary
            @tabChange="handleTabChange"
          >
            <asc-tab-title title="My Airline Workspace" />
            <asc-tab-title title="Collins Ascentia Workspace" />
          </asc-tab>
          <asc-tab-body :value="selectedTab">
            <asc-tab-item class="asc-main-tab-item">
              <div class="workspace-header">
                <div class="workspace-header--breadcrumb">
                  <asc-link-button
                    text="My Airline Workspace"
                    :disabled="
                      !getWorkspaceBreadcrumb && !getDashboardBreadcrumb
                    "
                    :uppercase="false"
                    @click="handleClickMyAirlineWorkspaceBreadcrumb()"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="selectedWorkspace"
                    text="/"
                    :uppercase="false"
                    :disabled="true"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="selectedWorkspace"
                    :text="getWorkspaceBreadcrumb"
                    :uppercase="false"
                    :disabled="!isDashboardSelected ? true : false"
                    @click="handleClickWorkspaceBreadcrumb()"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="isDashboardSelected"
                    text="/"
                    :uppercase="false"
                    :disabled="true"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="isDashboardSelected"
                    :text="getDashboardBreadcrumb"
                    :uppercase="false"
                    :disabled="true"
                  ></asc-link-button>
                </div>
                <div
                  v-if="isDashboardSelected"
                  class="workspace-header--sharing"
                >
                  <span class="label">Shared with: </span>
                  <span class="value">{{ sharedWith }}</span>
                </div>
              </div>
              <div
                v-if="!isDashboardSelected"
                class="asc-main-tab-item--create-button"
              >
                <asc-accent-button
                  button-text="Dashboard"
                  icon="mdi-plus"
                  icon-position="left"
                  :on-click="onCreateNewDashboard"
                ></asc-accent-button>
              </div>

              <asc-power-bi-my-airline-workspace-wrapper
                v-if="!isDashboardSelected"
                :airline-workspaces="airlineWorkspaces"
                :airline-reports="getReports"
                :update-selected-workspace="updateSelectedWorkspace"
                :selected-workspace="selectedWorkspace"
                :update-selected-dashboard="updateSelectedDashboard"
                :is-report-duplicated="isReportDuplicated"
                @switchPermissions="switchPermissionsSetting"
                @handleDeleteReport="handleDeleteReport"
                @handleSetReadonlyMode="handleSetReadonlyMode"
                @handleDuplicateReport="handleDuplicateReport"
                @updatePermissions="updatePermissions"
              ></asc-power-bi-my-airline-workspace-wrapper>
            </asc-tab-item>
            <asc-tab-item class="asc-main-tab-item">
              <template v-if="selectedTab === 1">
                <div class="workspace-header--breadcrumb">
                  <asc-link-button
                    text="Collins Ascentia Workspace"
                    :disabled="
                      !getWorkspaceBreadcrumb && !getDashboardBreadcrumb
                    "
                    :uppercase="false"
                    @click="handleClickMyAirlineWorkspaceBreadcrumb()"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="selectedWorkspace"
                    text="/"
                    :uppercase="false"
                    :disabled="true"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="selectedWorkspace"
                    :text="getWorkspaceBreadcrumb"
                    :uppercase="false"
                    :disabled="!isDashboardSelected ? true : false"
                    @click="handleClickWorkspaceBreadcrumb()"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="isDashboardSelected"
                    text="/"
                    :uppercase="false"
                    :disabled="true"
                  ></asc-link-button>
                  <asc-link-button
                    v-if="isDashboardSelected"
                    :text="getDashboardBreadcrumb"
                    :uppercase="false"
                    :disabled="true"
                  ></asc-link-button>
                </div>
                <asc-power-bi-my-airline-workspace-wrapper
                  v-if="!isDashboardSelected"
                  is-collins-workspace-tab
                  :airline-workspaces="airlineWorkspaces"
                  :airline-reports="getReports"
                  :update-selected-workspace="updateSelectedWorkspace"
                  :selected-workspace="selectedWorkspace"
                  :update-selected-dashboard="updateSelectedDashboard"
                  :is-report-duplicated="isReportDuplicated"
                  @handleSetReadonlyMode="handleSetReadonlyMode"
                  @handleDuplicateReport="handleDuplicateReport"
                ></asc-power-bi-my-airline-workspace-wrapper>
              </template>
            </asc-tab-item>
            <asc-power-bi-dashboard-wrapper
              v-if="isDashboardSelected"
              :update-selected-dashboard="updateSelectedDashboard"
              :selected-dashboard="selectedDashboard"
              :selected-workspace="selectedWorkspace"
              :dashboard-embed-token="dashboardEmbedToken"
              :loading="isDashboardLoading"
              :airline-reports="airlineReports"
              :is-readonly-mode="isReadonlyMode"
              :dashboard-name-error-message="dashboardNameErrorMessage"
              @handleEllipsesSelection="handleEllipsesSelection"
              @handleCancel="handleCancel"
              @handleSave="handleSave"
              @checkValidName="checkValidName"
              @handleUpdateDashboardName="handleUpdateDashboardName"
            ></asc-power-bi-dashboard-wrapper>
          </asc-tab-body>
        </template>
      </v-col>
    </v-row>
    <asc-create-power-bi-dashboard-dialog
      :show-dialog="displayCreateDashboardDialog"
      title="Create A New Dashboard"
      sub-text="artModalSubText"
      :data="newDashboardValue"
      :airlines-data="mappedAirlineWorkspaces"
      :dataset-data="mappedPowerbiDatasets"
      :mapped-powerbi-all-datasets="mappedPowerbiAllDatasets"
      :show-airline="true"
      :show-report-type="true"
      :loading="isDialogLoading"
      :disabled="!isCreateDashboardButtonActive"
      :on-close="onCloseCreateDashboardDialog"
      :on-primary="onCreateDashboard"
      :on-secondary="onCancelCreateDashboardDialog"
      :dashboard-name-error-message="dashboardNameErrorMessage"
      :selected-workspace="selectedWorkspace"
      @handleUpdate="handleUpdate"
    ></asc-create-power-bi-dashboard-dialog>
    <asc-delete-power-bi-report-dialog
      :report-name="deleteReportName"
      :show-dialog="displayDeleteDialog"
      @onCancelDeleteDialog="onCancelDeleteDialog"
      @onDeleteDeleteDialog="onDeleteDeleteDialog"
    ></asc-delete-power-bi-report-dialog>
    <asc-confirmation
      v-if="showDeleteReportToast"
      :definition="deleteReportToastDefinition"
      :on-toast-action="handleUndoDeleteReport"
      :on-close="handleDeleteReportToastClose"
    >
    </asc-confirmation>
  </v-container>
</template>

<script>
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'
import AscTab from '@/components/atoms/AscTab'
import AscTabBody from '@/components/atoms/AscTabBody'
import AscTabItem from '@/components/atoms/AscTabItem'
import AscTabTitle from '@/components/atoms/AscTabTitle'
import AscPageComingSoon from '@/components/molecules/AscPageComingSoon'
import AppFeatureFlags from '@/utilities/appFeatureFlags'
import AscPowerBiMyAirlineWorkspaceWrapper from '../organisms/AscPowerBiMyAirlineWorkspaceWrapper.vue'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscLinkButton from '@/components/atoms/AscLinkButton'
import AscCreatePowerBiDashboardDialog from '../molecules/AscCreatePowerBiDashboardDialog.vue'
import AscDeletePowerBiReportDialog from '../molecules/AscDeletePowerBiReportDialog.vue'
import AscConfirmation from '../molecules/AscConfirmation.vue'
import AscPowerBiDashboardWrapper from '../organisms/AscPowerBiDashboardWrapper.vue'

export default {
  name: 'AscPowerBiTemplate',

  components: {
    AscPageHeader,
    AscPageTitle,
    AscTab,
    AscTabItem,
    AscTabBody,
    AscTabTitle,
    AscPageComingSoon,
    AscPowerBiMyAirlineWorkspaceWrapper,
    AscAccentButton,
    AscCreatePowerBiDashboardDialog,
    AscLinkButton,
    AscPowerBiDashboardWrapper,
    AscDeletePowerBiReportDialog,
    AscConfirmation,
  },

  props: {
    currentTab: {
      type: Number,
      default: 0,
    },
    onTabChange: {
      type: Function,
      default: () => {},
    },
    airlineWorkspaces: {
      type: Array,
      default: () => [],
    },
    mappedAirlineWorkspaces: {
      type: Array,
      default: () => [],
    },
    mappedPowerbiAllDatasets: {
      type: Array,
      default: () => [],
    },
    mappedPowerbiDatasets: {
      type: Array,
      default: () => [],
    },
    newDashboardValue: {
      type: Object,
      default: () => {},
    },
    dashboardNameErrorMessage: {
      type: String,
      default: '',
    },
    isCreateDashboardButtonActive: {
      type: Boolean,
      default: false,
    },
    isDialogLoading: {
      type: Boolean,
      default: false,
    },
    handleCreateNewDashboard: {
      type: Function,
      default: () => {},
    },
    isReportDuplicated: {
      type: Boolean,
      default: false,
    },
    displayCreateDashboardDialog: {
      type: Boolean,
      default: false,
    },
    airlineReports: {
      type: Array,
      default: () => [],
    },
    isDashboardLoading: {
      type: Boolean,
      default: false,
    },
    deleteReportName: {
      type: String,
      default: '',
    },
    displayDeleteDialog: {
      type: Boolean,
      default: false,
    },
    showDeleteReportToast: {
      type: Boolean,
      default: false,
    },
    deleteReportToastDefinition: {
      type: Array,
      default: () => [],
    },
    dashboardEmbedToken: {
      type: Object,
      default: null,
    },
    isReadonlyMode: {
      type: Boolean,
      default: true,
    },
    selectedDashboard: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedTab: this.currentTab,
      selectedWorkspace: null,
      isDashboardViewDelete: false,
      newlyCreateddata: null,
    }
  },

  computed: {
    getReports() {
      return this.selectedTab === 1
        ? this.airlineReports.filter(rep => rep.isCollinsProvided)
        : this.airlineReports.filter(rec => !rec.isCollinsProvided)
    },

    isPowerBiPageActive() {
      return AppFeatureFlags.getPowerBiPage()
    },
    getWorkspaceBreadcrumb() {
      return this.selectedWorkspace?.friendlyName
    },
    getDashboardBreadcrumb() {
      return this.selectedDashboard?.name
    },
    sharedWith() {
      return this.selectedDashboard?.isShared
        ? `All ${this.selectedDashboard?.pbiDatasets[0].pbiWorkspaceName} Users`
        : 'Only Me'
    },
    isDashboardSelected() {
      return this.selectedDashboard?.id
    },
  },

  watch: {
    currentTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedTab = newVal
      }
    },
  },

  methods: {
    handleTabChange(whichTab) {
      if (this.onTabChange) {
        this.handleClickMyAirlineWorkspaceBreadcrumb()
        this.onTabChange(whichTab)
      }
    },
    onCreateNewDashboard() {
      this.$emit('onCreateNewDashboard')
    },
    onCancelCreateDashboardDialog() {
      this.$emit('onCancelCreateDashboardDialog')
    },
    onCloseCreateDashboardDialog() {
      this.$emit('onCloseCreateDashboardDialog')
    },
    async onCreateDashboard() {
      this.$emit('onCreateDashboard', newDashboard =>
        this.updateSelectedDashboard(newDashboard),
      )
      this.$emit('handleSetReadonlyMode', false)
    },
    handleUpdate(dashboardSelection) {
      if (this.selectedWorkspace && dashboardSelection.pbiAirline === null) {
        dashboardSelection.pbiAirline = this.mappedAirlineWorkspaces.find(
          x => x.pbiWorkspaceId === this.selectedWorkspace.pbiWorkspaceId,
        )
      }
      this.$emit('handleUpdate', dashboardSelection)
    },
    updateSelectedWorkspace(val) {
      this.selectedWorkspace = val
    },
    handleClickMyAirlineWorkspaceBreadcrumb() {
      this.updateSelectedWorkspace(null)
      this.removeSelectedDashboard()
      this.$emit('handleSetReadonlyMode', true)
    },
    handleClickWorkspaceBreadcrumb() {
      this.removeSelectedDashboard()
      this.$emit('handleSetReadonlyMode', true)
    },
    switchPermissionsSetting(selectedObject) {
      this.$emit('switchPermissionsSetting', selectedObject)
    },

    updateSelectedDashboard(val) {
      if (
        this.airlineWorkspaces.length > 1 &&
        this.selectedWorkspace?.id !== val.pbiDatasets[0].pbiWorkspaceId
      ) {
        this.selectedWorkspace = this.airlineWorkspaces.find(
          x => x.id === val.pbiDatasets[0].pbiWorkspaceId,
        )
      }
      this.$emit('onSelectDashboard', val)
    },
    removeSelectedDashboard() {
      this.$emit('removeSelectedDashboard')
    },
    handleEllipsesSelection(selectedObj) {
      if (selectedObj.selectionKey === 'Delete') {
        this.isDashboardViewDelete = true
        this.$emit('handleDeleteReport', selectedObj)
      } else if (selectedObj.selectionKey === 'Edit') {
        this.handleSetReadonlyMode(false)
      } else if (selectedObj.selectionKey === 'Manage Permissions') {
        this.updatePermissions(selectedObj)
      } else if (
        selectedObj.selectionKey === 'Duplicate' ||
        selectedObj.selectionKey === 'Duplicate to My Airline Workspace'
      ) {
        selectedObj['isDuplicatedFromDashboardView'] = true
        this.$emit('handleDuplicateReport', selectedObj)
      }
    },
    handleDeleteReport(selectedItem) {
      this.$emit('handleDeleteReport', selectedItem)
    },
    updatePermissions(selectedItem) {
      this.$emit('updatePermissions', selectedItem)
    },
    handleDuplicateReport(selectedItem) {
      this.$emit('handleDuplicateReport', selectedItem)
    },
    onDeleteDeleteDialog() {
      if (this.isDashboardViewDelete) {
        this.removeSelectedDashboard()
      }
      this.$emit('onDeleteDeleteDialog')
    },
    onCancelDeleteDialog() {
      this.isDashboardViewDelete = false
      this.$emit('onCancelDeleteDialog')
    },
    handleUndoDeleteReport(deletedData) {
      this.isDashboardViewDelete = false
      this.$emit('handleUndoDeleteReport', deletedData)
    },
    handleDeleteReportToastClose(deletedData) {
      this.isDashboardViewDelete = false
      this.$emit('handleDeleteReportToastClose', deletedData)
    },
    handleCancel() {
      this.$emit('handleCancel')
    },
    handleSave() {
      this.$emit('handleSave')
    },
    checkValidName(dashboard) {
      this.$emit('checkValidName', dashboard)
    },
    handleUpdateDashboardName(value) {
      this.$emit('handleUpdateDashboardName', value)
    },
    handleSetReadonlyMode(value) {
      this.$emit('handleSetReadonlyMode', value)
    },
  },
}
</script>

<style lang="scss">
.asc-power-bi-template {
  background-color: $gray-100;

  #asc-main-tabs.asc-tabs {
    .v-tabs-bar__content {
      background-color: $primary-white !important;
    }
  }

  .asc-tab__content--primary {
    background-color: $primary-white !important;

    .asc-main-tab-item {
      .asc-tab__content--secondary {
        .asc-tab__content--primary {
          background-color: $gray-0 !important;
        }
      }
      &--create-button {
        padding-bottom: 20px;
      }
    }
  }

  .asc-container--container .asc-container--headerWrapper {
    padding: 0 16px 8px 16px;
  }

  .workspace-header {
    display: flex;
    &--breadcrumb {
      flex: auto;
      padding: 0 16px 16px 0;
      .v-btn__content {
        padding-right: 4px;
      }
      .asc-link-button--disabled .asc-link-button--label {
        color: $gray-700 !important;
      }
    }

    &--sharing {
      flex: initial;
      font-size: 13px;
      font-weight: 400;

      .label {
        color: $gray-700 !important;
      }
    }
  }
}
</style>
